import { makeStyles } from "tss-react/mui";

const PRIMARY = "#ff5a6e";
const PRIMARY_DARK = "#e44057";
const DARK = "#333";
const LIGHT = "#f8f9fa";

export const useStyles = makeStyles()(() => ({
  "@global": {
    "@keyframes modalAppear": {
      "0%": {
        opacity: 0,
        transform: "translateY(20px)",
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  modal: {
    background: `linear-gradient(145deg, #ffffff, ${LIGHT})`,
    width: 450,
    borderRadius: 16,
    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    animation: "$modalAppear 0.5s ease",
    position: "relative",
  },

  modalHeader: {
    background: "linear-gradient(135deg, #2c3e50, #4a5568)",
    color: "#fff",
    padding: "1.5rem",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background:
        "radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)",
      transform: "rotate(30deg)",
    },
  },

  modalTitle: {
    fontSize: "1.4rem",
    fontWeight: 700,
    margin: 0,
    position: "relative",
    paddingRight: "4rem",
  },

  premiumBadge: {
    background: "linear-gradient(135deg, #ffcc33, #ff9933)",
    color: "#333",
    padding: "4px 8px",
    borderRadius: 50,
    fontSize: "0.7rem",
    fontWeight: 600,
    position: "absolute",
    right: 0,
    top: 25,
    boxShadow: "0 2px 10px rgba(255, 153, 51, 0.3)",
  },

  modalBody: {
    padding: "2rem",
    color: "#333",
    "& p": {
      margin: 0,
    },
  },

  featureList: {
    margin: "1.5rem 0",
    padding: 0,
    listStyleType: "none",
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem",
    paddingLeft: 10,
  },
  featureIcon: {
    flexShrink: 0,
    background: `linear-gradient(135deg, ${PRIMARY}, ${PRIMARY_DARK})`,
    width: 28,
    height: 28,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
    color: "#fff",
    fontSize: "0.8rem",
    boxShadow: "0 3px 8px rgba(255, 90, 110, 0.3)",
  },
  featureText: {
    fontWeight: 500,
  },

  modalFooter: {
    display: "flex",
    padding: "0 2rem 2rem",
    gap: "1rem",
  },

  btn: {
    padding: "12px 24px",
    borderRadius: 50,
    fontWeight: 600,
    fontSize: "0.95rem",
    transition: "all 0.3s ease",
    cursor: "pointer",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },

  btnCancel: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    color: "#555",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.15)",
    },
  },

  btnUpgrade: {
    background: `linear-gradient(135deg, ${PRIMARY}, ${PRIMARY_DARK})`,
    color: "#fff",
    boxShadow: "0 4px 15px rgba(255, 90, 110, 0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #ff6b7d, #ff4055)",
      transform: "translateY(-2px)",
      boxShadow: "0 7px 20px rgba(255, 90, 110, 0.5)",
    },
  },

  btnIcon: {
    marginLeft: 8,
  },
}));
